const CAPITALIZE_REGEX = /(?:^|[\s-])\p{L}/gu

export function capitalizeFirstLetter(str: string = ''): string {
  return str.replace(CAPITALIZE_REGEX, c => c.toUpperCase())
}
